<template>
  <div class="goodsManagePage">
    <div class="banner">
      <img src="../../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_item">辅助功能&内容管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">知识付费内容管理</div>
    </div>

    <div class="input_wrap flex-rowl">
      <div class="input_box search">
        <van-field
          v-model="params.keyword"
          ref="input"
          placeholder="关键词查找"
          @focus="handleFocus"
          @blur="handleBlur"
          @keyup.enter="handleSearch"
        />
      </div>
      <div class="primary-button" @click="handleSearch">查找→</div>
    </div>

    <div class="main_content">
      <div class="data_list" v-if="dataList.length > 0">
        <div class="item_card" v-for="item in dataList" :key="item.id">
          <div class="img_box">
            <video :src="item.videoidstr" controls></video>
          </div>
          <div class="block">
            <p>知识产权标题：{{ item.kpidstr }}</p>
            <p>用户姓名：{{ item.truename }}</p>
            <p>访问时间：{{ item.addtime | formatDate }}</p>
          </div>
        </div>
      </div>
      <van-empty
        v-else-if="dataList.length == 0 && !loading"
        description="暂无数据"
      />
    </div>

    <div class="fixd_button_btm flex-rowl" v-if="isShowTabbar">
      <!-- <div class="return-fixd"> -->
      <div class="item" @click="handleReturn">返回</div>
    </div>
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getKonwledgeVisitList } from "../../../api/knowledge";
import { mapState } from "vuex";
export default {
  name: "kVisitlist",
  data() {
    return {
      isShowTabbar: true,
      loading: false,
      searchTxt: "",
      listTotal: 0,
      dataList: [],
      params: {
        kpid: "",
        pageindex: 1,
        pagesize: 15,
        keyword: "",
      },
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  mounted() {
    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.params.kpid = id;
        this.initData();
      } else {
        this.$router.back();
      }
    },

    handleSearch() {
      this.params.pageindex = 1;
      this.initData();
    },
    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },

    initData() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getKonwledgeVisitList(this.params).then((res) => {
        this.dataList = [...this.dataList, ...res.list];
        this.listTotal = res.total;
        this.loading = false;
        Toast.clear();
      });
    },
    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.pageindex += 1;
        this.initData();
      }
    },
    handleReturn() {
      history.back();
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  padding-bottom: 420px;
  .input_wrap {
    padding: 20px 45px 30px;
    box-sizing: border-box;
    .primary-button {
      width: 145px;
      margin-left: 20px;
      font-size: 26px;
    }
  }
  .input_tip {
    font-size: 14px;
    margin-bottom: 60px;
    color: #aaaaaa;
    .btn {
      margin-left: 30px;
      background: #6e5c86;
      color: #fff;
      padding: 0 15px;
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      border-radius: 5px;
    }
  }
  .main_content {
    width: 650px;
    margin: 60px auto 100px;
    .data_list {
      // padding-bottom: 320px;
      .item_card {
        border: 2px solid #dedede;
        border-radius: 30px;
        padding: 45px 37px 87px;
        box-sizing: border-box;
        font-size: 22px;
        color: #404d6c;
        position: relative;
        margin-bottom: 55px;
        .block {
          margin-bottom: 30px;
        }
        .img_box {
          width: 250px;
          height: 250px;
          margin: 35px auto;
          background: #f8f8f8;
          overflow: hidden;
          video {
            width: 100%;
            height: 100%;
          }
        }
        h1 {
          font-size: 30px;
          color: #404d6c;
          margin-bottom: 12px;
        }
        p {
          margin-bottom: 10px;
        }
        .editBtn {
          width: 200px;
          height: 50px;
          background: #6e5c86;
          border-radius: 25px;
          text-align: center;
          line-height: 50px;
          font-size: 20px;
          color: #fff;
          position: absolute;
          right: 20px;
          bottom: 20px;
        }
      }
    }
  }
}
</style>